import { GerarParcelasInput } from '../schemas/parcela';

export interface ParcelaGerada {
  numero: number;
  valor: number;
  dataVencimento: string;
}

/**
 * Gera de forma determinística N parcelas a partir de um valor total e data inicial.
 * A última parcela absorve os centavos restantes da divisão.
 */
export function gerarParcelas({
  valorTotal,
  numeroParcelas,
  dataPrimeiroVencimento,
}: GerarParcelasInput): ParcelaGerada[] {
  if (numeroParcelas <= 0) {
    throw new Error('Número de parcelas deve ser maior que zero');
  }

  // Converter para centavos inteiros para evitar problemas de ponto flutuante
  const totalCentavos = Math.round(valorTotal * 100);
  const valorBaseCentavos = Math.floor(totalCentavos / numeroParcelas);
  const centavosRestantes = totalCentavos - valorBaseCentavos * numeroParcelas;

  const parcelas: ParcelaGerada[] = [];
  const baseDate = new Date(`${dataPrimeiroVencimento}T00:00:00Z`);

  for (let i = 1; i <= numeroParcelas; i++) {
    // Adiciona 1 mês para cada parcela subsequente (i = 1 mantém a data inicial)
    const dueDate = new Date(baseDate);
    dueDate.setUTCMonth(baseDate.getUTCMonth() + (i - 1));

    const yyyy = dueDate.getUTCFullYear();
    const mm = String(dueDate.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(dueDate.getUTCDate()).padStart(2, '0');
    const dataVencimento = `${yyyy}-${mm}-${dd}`;

    // A última parcela recebe os centavos excedentes da divisão
    const valorCentavos = i === numeroParcelas ? valorBaseCentavos + centavosRestantes : valorBaseCentavos;

    parcelas.push({
      numero: i,
      valor: valorCentavos / 100,
      dataVencimento,
    });
  }

  return parcelas;
}
